export const ACCESSORY_PREFIX = 'accessory_';
export const USER_NAME_PREFIX = 'USER_NAME_';
export const USER_INFO_PREFIX = 'USER_INFO_';

// export const BASE_URL = 'http://192.168.1.5:8082'
// export const BASE_URL = 'http://localhost:8080'
// export const BASE_API = BASE_URL+'/api';

export const BASE_URL = 'https://ruichangkeji.com' //生产环境
export const BASE_API = BASE_URL+'/api2';

// export const BASE_URL = 'http://8.140.227.143:86' //测试环境
// export const BASE_API = BASE_URL+'/api';
export const DOWNLOAD_URL = BASE_API +'/file/download?imgName=';
